import { createStore } from 'vuex'
import router from '../router';
import Swal from 'sweetalert2';
import { fetchJS, services } from '@/utilities/general'

const INACTIVITY_TIMEOUT = 10 * 60 * 1000;   // 10 minutos sin actividad
const SESSION_PROMPT_TIMEOUT = 30 * 1000;    // 30 segundos para responder

export default createStore({
    state: {
        user: JSON.parse(localStorage.getItem('user')) || null,
        logoutTimer: null,
        sessionPromptOpen: false
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
            localStorage.setItem('user', JSON.stringify(user));
        },
        updateUser(state, payload) {
            state.user = {
                ...state.user,
                ...payload
            }
            localStorage.setItem('user', JSON.stringify(state.user))
        },
        logout(state) {
            state.user = null;
            localStorage.removeItem('user');
            clearTimeout(state.logoutTimer);
        },
        setSessionPromptOpen(state, value) {
            state.sessionPromptOpen = value;
        },
        setLogoutTimer(state, timer) {
            state.logoutTimer = timer;
        },
        //  modificar el estado de alerta de cambio de contraseña
        // creado al iniciar sesión
        dismissPwdAlert(state) {
            if (!state.user) return;
            state.user = { ...state.user, alerta_pwd: false, primera_vez: 10 };
            localStorage.setItem('user', JSON.stringify(state.user));
        },
        changePs(state) {
            if (!state.user) return;
            state.user = { ...state.user, ps: {
                'estatus' : true
            } };
            localStorage.setItem('user', JSON.stringify(state.user));
        },
        clearLogoutTimer(state) {
            if (state.logoutTimer) {
                clearTimeout(state.logoutTimer);
                state.logoutTimer = null;
            }
        }
    },
    getters: {
        isAuthenticated: state => !!state.user,
        user: state => state.user,
        totpActivo: state => state.user?.totp_activo === true
    },
    actions: {
        login({ commit, dispatch }, user) {
            // Here you would usually make a request to the server
            // For simplicity, we'll just commit the user directly
            commit('setUser', user);
            dispatch('startLogoutTimer');
        },
        logout({ commit, dispatch }) {
            commit('logout');
            dispatch('clearLogoutTimer');
        },
        updateUser({ commit }, payload) {
            commit('updateUser', payload)
        },
        startLogoutTimer({ commit, dispatch, state }) {
            dispatch('clearLogoutTimer');

            if (!this.getters.isAuthenticated) {
                return
            }
            const timer = setTimeout(async () => {
                let timerInterval;
                const segundos = SESSION_PROMPT_TIMEOUT / 1000;
                commit('setSessionPromptOpen', true);
                const result = await Swal.fire({
                    icon: 'question',
                    title: '¿Sigues ahí?',
                    html: `¿Desea mantener la sesión activa?<br>La sesión se cerrará automáticamente en <b>${segundos}</b> segundos.`,
                    timer: SESSION_PROMPT_TIMEOUT,
                    timerProgressBar: true,
                    showCancelButton: true,
                    confirmButtonText: "Continuar",
                    cancelButtonText: "Cerrar sesión",
                    allowOutsideClick: false, // No permitir cerrar haciendo clic fuera
                    allowEscapeKey: false,    // No permitir cerrar con la tecla Escape
                    customClass: {
                        confirmButton: 'button primary w-7',
                        cancelButton: 'button white w-7'
                    },
                    buttonsStyling: false,
                    didOpen: () => {
                        const contador = Swal.getHtmlContainer().querySelector("b");
                        timerInterval = setInterval(() => {
                            contador.textContent = Math.ceil((Swal.getTimerLeft() || 0) / 1000);
                        }, 250);
                    },
                    willClose: () => {
                        clearInterval(timerInterval);
                    }
                })
                commit('setSessionPromptOpen', false);

                if (result.isConfirmed) {
                    dispatch('startLogoutTimer');
                    return
                }
                if (!state.user) {
                    return
                }
                try {
                    await fetchJS({
                        url: services.cerrar_session(),
                        redirect: "follow",
                        method: 'POST',
                    });
                } catch (error) {
                    console.error('Logout failed:', error);
                } finally {
                    dispatch('logout');
                    router.push({ path: '/login' }).then(() => { router.go(0) });
                }
            }, INACTIVITY_TIMEOUT);
            commit('setLogoutTimer', timer);
        },
        clearLogoutTimer({ commit }) {
            commit('clearLogoutTimer');
        },
        resetLogoutTimer({ dispatch, state }) {
            // Mientras la alerta está abierta, solo la respuesta del usuario mantiene la sesión
            if (state.sessionPromptOpen) {
                return
            }
            dispatch('startLogoutTimer');
        }
    },
    modules: {
    }
})
